/**
 * 도구명 → 사람이 읽는 이름 (F-0 §1.1 L4 이관분).
 *
 * 구 Nitro 가 들고 있던 표다. 이걸 잃으면 화면에 `search_internal_knowledge` 같은 식별자가
 * 그대로 뜬다 — 사용자에게는 오류처럼 보인다.
 *
 * **판정이나 값 재계산이 아니라 표현일 뿐이다**(프런트 규율 §3-2). 없는 도구는 이름을 그대로
 * 보여준다 — 지어낸 라벨보다 정확한 식별자가 낫다.
 *
 * ⚠ 구 표에는 백엔드에 없는 도구 3종(`find_vendor`·`record_wbs`·`record_assignment` 계열 일부)이
 * 남아 있었고, 그 뒤 추가된 도구(WBS·마스터플랜 접수/취소·외부 반영)는 빠져 있었다. 여기서는
 * **현재 AGENT_TOOLS 기준**으로 맞춘다.
 */
export const TOOL_LABELS: Readonly<Record<string, string>> = {
  read_document: '문서 판독',
  web_search: '웹 검색',
  search_internal_knowledge: '사내 지식 검색',
  find_document_template: '문서 양식 검색',
  check_document_completeness: '양식 완결성 점검',
  find_staff: '담당 검색',
  find_task_template: '작업표준 검색',
  find_labor_rate: '노임단가 조회',
  find_company: '거래처 검색',
  find_partner_for_process: '공정별 협력사 검색',
  find_contact: '담당자 연락처 검색',
  record_sourcing: '소싱 반영',
  record_assignment: '배정 반영',
  assess_request_sufficiency: '충분도 점검',
  review_manufacturability: '제작성 판정',
  show_request_status: '요청 현황',
  author_masterplan: '마스터플랜 저작',
  get_masterplan_result: '마스터플랜 결과 확인',
  cancel_masterplan: '저작 중단',
  reflect_to_destination: '산출물 반영',
  list_reflected_outputs: '반영 목록',
  undo_reflection: '반영 되돌리기',
  place_order: '발주',
}

export function labelFor(toolName: string): string {
  return TOOL_LABELS[toolName] ?? toolName
}
